/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon20Light = forwardRef('WeatherUmbrellaIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.997 1.5a.5.5 0 0 0-1 0v1.514a8.5 8.5 0 0 0-7.994 8.167.792.792 0 0 0 .794.819h7.2v4.501A1.499 1.499 0 1 1 7 16.5a.5.5 0 0 0-1 0 2.5 2.5 0 0 0 4.997.001V12h7.2a.792.792 0 0 0 .794-.819 8.501 8.501 0 0 0-7.994-8.167V1.5ZM3.014 11H17.98a7.5 7.5 0 0 0-14.967 0Z" })));
});
